export default __webpack_public_path__ + "images/db-logos/google_search_console.png";